<script lang="ts">
  import AccordionChevron from '$icons/AccordionChevronIcon.svelte';
  import type { FPost } from 'garden-common';

  export let tagging: FPost<string>['tags'][0];
</script>

{#if typeof tagging !== 'string'}
  <details class="border-blueish-grey-200 border rounded-[16px] px-[16px] py-[12px] appearance-none group">
    <summary class="flex text-blueish-grey-900 font-medium list-none select-none cursor-pointer">
      <div class="flex-grow">
        {tagging.tagged.username}
      </div>

      <div class="group-open:rotate-180 duration-200">
        <AccordionChevron />
      </div>
    </summary>

    <div>
      <div class="h-px bg-grey-transparency-dark-4 mt-[12px]" />

      <div class="mt-[16px]">
        <div class="--label">Timeline</div>
        <div class="--value">None</div>
      </div>

      <div class="grid grid-cols-2 mt-[24px]">
        <div>
          <div class="--label">Completion date</div>
          <div class="--value">None</div>
        </div>

        <div>
          <div class="--label">Completion time</div>
          <div class="--value">None</div>
        </div>
      </div>
    </div>
  </details>
{/if}

<style lang="postcss">
  .--label {
    @apply text-blueish-grey-600 font-medium text-sm;
  }

  .--value {
    @apply text-garden-grey-800 font-medium text-sm;
  }

  @keyframes details-show {
    from {
      opacity: 0;
      transform: var(--details-translate, translateY(-0.5em));
    }
  }

  details[open] > *:not(summary) {
    animation: details-show 150ms ease-in-out;
  }
</style>
